import React from 'react';
import styled from 'styled-components';

const StyledToy = styled.div`
  flex: 1 0 20%;
  border: 0px solid grey;
  height: fit-content;
  text-align: center;
  box-sizing: border-box;
  ${({ isSelected }) => isSelected && 'filter:drop-shadow(0px 0px 10px orange);'}
  
  @media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){
    ${({ isSelected }) => isSelected && 'opacity:0.2;'}
    ${({ isSelected }) => isSelected && 'margin:-10px;'}
  }
  @media (max-width: 500px) {
    flex: 1 0 50%;
  }
`;

const Toy = ({
  id,
  name,
  img,
  onClick,
  isSelected
}) => {
  return (
    <StyledToy
      onClick={() => onClick(id)}
      isSelected={isSelected}
    >
      <img src={img} alt={name} width="100%" />
    </StyledToy>
  );
};

export {
  Toy
}
